<div class="subtype-tags">
  @for (option of selectableOptions; track option.id) {
    <button type="button" class="subtype-tag" [class.subtype-tag--selected]="option.displayedName === value" (click)="select(option)">
      {{ option.displayedName }}
    </button>
  }
</div>

<div class="subtype-footer">
  @if (!showCustomInput()) {
    <button type="button" class="subtype-tag subtype-tag--autre" (click)="openCustomInput()">Autre...</button>
  } @else {
    <div class="subtype-custom-row">
      <input
        #customInput
        class="subtype-custom-input"
        type="text"
        placeholder="Précisez le type..."
        [ngModel]="customValue()"
        (ngModelChange)="customValue.set($event)"
        (keydown)="onCustomKeydown($event)"
      />
      <button
        type="button"
        class="subtype-custom-ok"
        [class.subtype-custom-ok--active]="customValue().trim().length > 0"
        (click)="confirmCustom()"
      >
        OK
      </button>
    </div>
  }
</div>
